import { motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { heroVariant, staggerContainer, sectionVariant, viewportOnce } from "@/lib/motion";
import { usePageContent } from "@/hooks/usePageContent";

const fallback = {
  label: "Support",
  headline: "Frequently Asked Questions",
  faqs: [
    { q: "How do you measure success?", a: "We establish clear KPIs at project start and track progress through regular reporting. Success metrics vary by engagement but always tie to business outcomes." },
    { q: "What's your typical engagement model?", a: "We offer retainer-based partnerships for ongoing work and project-based engagements for specific initiatives. Most clients start with a defined project and expand from there." },
    { q: "How long until we see results?", a: "Timeline varies by service. SEO typically shows results in 3-6 months, while paid media can show immediate improvement. We set realistic expectations upfront." },
    { q: "Do you work with specific industries?", a: "We specialize in B2B SaaS, eCommerce, and professional services but have experience across many verticals." },
    { q: "What makes you different from other agencies?", a: "We're systems-thinkers, not campaign-runners. We build integrated growth engines, not siloed campaigns." },
    { q: "How do we get started?", a: "Start with a discovery call. We'll discuss your goals, assess fit, and outline potential approaches." },
  ],
};

const FAQs = () => {
  const { content } = usePageContent("faqs", fallback);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <section className="relative pt-28 pb-10 md:pt-36 md:pb-16 lg:pt-44 lg:pb-20">
        <div className="container-wide">
          <motion.div initial="hidden" animate="visible" variants={staggerContainer} className="max-w-3xl">
            <motion.span variants={heroVariant} className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-medium mb-4 block">
              {content.label}
            </motion.span>
            <motion.h1 variants={heroVariant} className="font-display text-4xl md:text-5xl font-semibold text-foreground mb-6">
              {content.headline}
            </motion.h1>
          </motion.div>
        </div>
      </section>
      <section className="py-10 md:py-16 border-t border-border">
        <div className="container-wide max-w-3xl">
          <motion.div initial="hidden" whileInView="visible" viewport={viewportOnce} variants={sectionVariant}>
            <Accordion type="single" collapsible className="space-y-4">
              {content.faqs.map((faq: any, i: number) => (
                <AccordionItem key={i} value={`item-${i}`} className="border border-border px-6">
                  <AccordionTrigger className="text-left text-foreground">{faq.q}</AccordionTrigger>
                  <AccordionContent className="text-muted-foreground">{faq.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default FAQs;
